//Set up custom Iodine rules (form validation)
window.Iodine.setErrorMessage('required','Dieses Feld darf nicht leer sein');
window.Iodine.setErrorMessage('same','Die Felder müssen übereinstimmen');
window.Iodine.setErrorMessage('email','Bitte geben Sie eine gültige Email Adresse ein');
window.Iodine.setErrorMessage('minLength','Bitte geben Sie mindestens [PARAM] Zeichen ein');
window.Iodine.setErrorMessage('maxLength','Bitte geben Sie höchstens [PARAM] Zeichen ein');
window.Iodine.setErrorMessage('regexMatch','Bitte geben Sie einen gültigen Wert ein');
window.Iodine.setErrorMessage('zipCode','Bitte geben Sie eine gültige Postleitzahl ein');
window.Iodine.setErrorMessage('streetWithNr','Bitte geben Sie Straße & Hausnummer ein');
window.Iodine.setErrorMessage('consent','Bitte bestätigen Sie, dass Sie unsere Datenschutzbestimmungen und AGB zur Kenntnis genommen haben');

window.Iodine.rule('zipCode', (value) => window.Iodine.assertRegexMatch(value, '^(\\d{5})$'));
window.Iodine.rule('streetWithNr', (value) => {
    const regex= /^[A-Z][A-Za-zäöüÄÖÜß.\-\s]+?\s(\d+?[a-zA-Z\s]*?-?[\da-zA-Z\s]*?)\s?$/;
    const match = window.Iodine.assertRegexMatch(value, regex);
    return match;
});
Iodine.rule('consent', (value) => window.Iodine.assertRequired(value));

updateErrorMessages = function updateErrorMessages(validationResult,errors) {
    // replace error messages with validation data -> [fieldname]: 'Error Message Text'
    const validationData = Object.entries(validationResult.fields);
    validationData.forEach((element) => {
        errors[element[0]] = element[1].error;
    });
}